import styled from '@emotion/styled'

import tokens from '../../design/tokens'
import colorNames from '../../design/color-names'

const monthHeight = '30px'
const navigationWidth = '17px'

const { borderRadius, fontSize, fontWeight } = tokens

const arrowLeft = `<svg xmlns="http://www.w3.org/2000/svg"  preserveAspectRatio="xMidYMid" width="23.906" height="13.91" viewBox="0 0 23.906 13.91">
  <path d="M22.901,7.942 L3.388,7.942 L7.665,12.209 C8.055,12.597 8.055,13.227 7.665,13.615 C7.471,13.809 7.216,13.906 6.961,13.906 C6.706,13.906 6.451,13.809 6.257,13.615 L0.279,7.651 C0.279,7.651 0.279,7.650 0.278,7.650 C0.187,7.559 0.114,7.450 0.064,7.329 C-0.037,7.085 -0.037,6.811 0.064,6.568 C0.114,6.447 0.187,6.338 0.278,6.247 C0.279,6.246 0.279,6.246 0.279,6.246 L6.257,0.282 C6.646,-0.106 7.276,-0.106 7.665,0.282 C8.055,0.670 8.055,1.300 7.665,1.688 L3.388,5.955 L22.901,5.955 C23.451,5.955 23.897,6.399 23.897,6.948 C23.897,7.497 23.451,7.942 22.901,7.942 Z" 
    fill="${colorNames.java}"
  />
</svg>`

const arrowRight = `<svg xmlns="http://www.w3.org/2000/svg"  preserveAspectRatio="xMidYMid" width="23.937" height="13.91" viewBox="0 0 23.937 13.91">
  <path d="M23.847,6.568 C23.948,6.811 23.948,7.085 23.847,7.329 C23.797,7.450 23.725,7.559 23.633,7.650 C23.633,7.650 23.633,7.651 23.633,7.651 L17.655,13.615 C17.460,13.809 17.206,13.906 16.951,13.906 C16.696,13.906 16.441,13.809 16.246,13.615 C15.857,13.227 15.857,12.597 16.246,12.209 L20.523,7.942 L1.011,7.942 C0.460,7.942 0.014,7.497 0.014,6.948 C0.014,6.399 0.460,5.955 1.011,5.955 L20.523,5.955 L16.246,1.688 C15.857,1.300 15.857,0.670 16.246,0.282 C16.635,-0.106 17.266,-0.106 17.655,0.282 L23.633,6.246 C23.633,6.246 23.633,6.246 23.633,6.247 C23.725,6.338 23.797,6.447 23.847,6.568 Z" 
    fill="${colorNames.java}"/>
</svg>
`

const DatePickerButtonContainer = styled.div`

  line-height: 0;

  .c-datepicker-button--active {
      background-color: ${colorNames.blueChill};
      color: ${colorNames.pureWhite};
      border-color: ${colorNames.blueChill};
      
  }
  .react-datepicker {
    /* top: -7px; */
    color: #333;
    background-color: ${colorNames.pureWhite};
    border: 1px solid ${colorNames.bombay};
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    border-radius: ${borderRadius.small};
    padding: 13px 15px 13px;
    font-size: ${fontSize.small};
    width: auto;
    position: relative;

    &__triangle,
    &__close-icon {
      display: none;
    }

    &__navigation {
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      border: none;
      color: transparent;
      cursor: pointer;
      height: ${monthHeight};
      width: ${navigationWidth};
      z-index: 1;
      display: block;
      position: absolute;
      top: 15px;
      outline: none;

      &--previous {
        left: 18px;
        color: ${colorNames.java};
        background-image: url('data:image/svg+xml;charset=utf8,${encodeURIComponent(
          arrowLeft
        )}'); 
      }

      &--next {
        right: 18px;
        background-image: url('data:image/svg+xml;charset=utf8,${encodeURIComponent(
          arrowRight
        )}'); 
      }
    }

    &__current-month {
      color: ${colorNames.tundora};
      font-weight: ${fontWeight.normal};
      font-size: ${fontSize.standard};
      line-height: ${monthHeight};
      font-family: 'Roboto';
      max-width: calc(100% - 2 * (${navigationWidth} + 0.5em));
      margin: 0 auto;
      margin-bottom: 5px;
    }

    &__day-name,
    &__day,
    &__time-name {
      min-width: 29px;
      line-height: 28px;
      width: auto;
      margin: 0;
      padding: 0;
    }

    &__day-name {
      color: ${colorNames.silver};
      font-family: 'Roboto', arial, sans-serif;
      font-size: 11px;
      line-height: 26px;
      font-weight: ${fontWeight.bold};
      text-transform: uppercase;
    }

    &__day {
      padding: 0;
      font-size: 12px;
      border-radius: 2px;
      color: #333;
      background-color: #fff;
      border: none;
      outline: none;

      &:hover {
        background-color: ${colorNames.java};
        color: ${colorNames.pureWhite};
      }

      &--selected {
        background-color: ${colorNames.mercury};
      }

      &--outside-month {
        color: ${colorNames.silverChalice};
      }

      &--disabled {
        color: ${colorNames.silverChalice};
        text-decoration: line-through;
        pointer-events: none;
      }
    }
  }

  .react-datepicker__month {
    margin: 0;
  }

  .react-datepicker__header {
    padding: 0;
    background-color: transparent;
    border-bottom: none;
  }

  .react-datepicker__month-text:hover {
    color: ${colorNames.pureWhite};
    background-color: ${colorNames.java};
  }

  .react-datepicker__day--disabled,
  .react-datepicker__month-text--disabled,
  .react-datepicker__quarter-text--disabled {
    cursor: default;
    color: #ccc !important;
    background-color: transparent !important;
  }

  .react-datepicker-popper[data-placement="bottom-start"] {
    margin-top: 4px;
  }

  .react-datepicker-popper[data-placement="top-start"] {
    margin-bottom: 4px;
  }
`

export default DatePickerButtonContainer
